import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=a0aad446&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=a0aad446&prod&lang=less&scoped=true"
import style1 from "./MenuList.vue?vue&type=style&index=1&id=a0aad446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aad446",
  null
  
)

export default component.exports